<template>
  <div class="creator_my_agency">
    <van-nav-bar placeholder safe-area-inset-top @click-left="onClickLeft" left-arrow />
    <van-row>
      <van-col class="creator_my_agency_title" span="8" offset="1">{{ $t('column.my_agency')}}</van-col>
      <van-col class="creator_my_agency_user" span="22" offset="1">
        <van-col span="5">
          <van-image
              round
              width="12vw"
              height="12vw"
              :src="userInfo.head_image"
              fit="cover"
          />
        </van-col>
        <van-col span="13">
          <van-col span="24" class="creator_my_agency_user_name"> {{ userInfo.nick_name }} </van-col>
          <van-col span="24" class="creator_my_agency_user_id"> ID:{{ userInfo.user_id }} </van-col>
        </van-col>
        <van-col span="6" class="creator_my_agency_user_lt">
          <img src="../assets/img/creator/creator_agency_message.png"  @click="privateMessage"/>
        </van-col>
      </van-col>
      <van-col class="creator_my_agency_change" span="8" offset="8" @click="changeAgencyShow = true">
        <van-cell :value="$t('column.change_agency')" is-link/>
      </van-col>
      <van-col class="creator_my_agency_section" span="22" offset="1">
        <van-col class="creator_my_agency_section_title" span="22" offset="1"> {{ $t('column.reminder')}}: </van-col>
        <van-col class="creator_my_agency_section_text" span="22" offset="1">{{ $t('column.my_agency_text1')}}</van-col>
        <van-col class="creator_my_agency_section_text" span="22" offset="1">{{ $t('column.my_agency_text2')}}</van-col>
      </van-col>
    </van-row>
    <van-popup v-model="changeAgencyShow" round  position="bottom" :style="{ height: '50%',width: '100%' }">
      <van-row>
        <van-col span="24" class="change_agency_show_title">{{ $t('column.change_agency')}}</van-col>
        <van-col span="22" offset="1" class="change_agency_show_name">{{ $t('column.agency_provided_by_agency')}}</van-col>
        <van-col span="22" offset="1" class="change_agency_show_field">
          <van-field v-model="agency_uid" :placeholder="$t('column.please_input_agency_id')" />
        </van-col>
        <van-col span="22" offset="1" class="change_agency_show_btn">
          <van-button color="linear-gradient(to left, #FF61F5, #A529FF)" :loading="loading" round block @click="changeAgency">{{ $t('column.bind')}}</van-button>
        </van-col>
      </van-row>
    </van-popup>
  </div>
</template>
<script>
import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import {Dialog, DatetimePicker} from "vant";

export default {
  data() {
    return {
      userInfo: {},
      changeAgencyShow: false,
      agency_uid: undefined,
      loading: false
    }
  },
  created() {
    this.getUserInfo()
  },
  methods: {
    // 获取用户信息
    getUserInfo() {
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_agency_change",{
        params:{uid: uid, token: token}
      }).then(res =>{
        console.log(res.data)
        if(res.data.status===1){
          this.userInfo = res.data.data
        }else{
          Toast(res.data.error)
        }
      })
    },
    onClickLeft() {
      // 返回上一页
      this.$router.go(-1)
    },
    privateMessage() {
      // 拦截跳转私信
      window.location.href="live://live?action=JumpUserPrivateMessage&id=" + this.userInfo.user_id
    },
    // 更换代理
    changeAgency() {
      this.loading = true
      const uid = this.$route.query.uid
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator&act=creator_user_bind",{
        params:{
          uid: uid,
          token: token,
          bind_user_id: this.agency_uid
        }
      }).then(res =>{
        this.loading = false
        console.log(res.data)
        Toast(res.data.error)
        if(res.data.status===1){
          this.changeAgencyShow = false
          this.getUserInfo();
        }
      })
    }
  }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/my_agency.vue